export default "__VITE_ASSET__CXWrpkBG__"